import { render, staticRenderFns } from "./adminHeader.vue?vue&type=template&id=0705b978&scoped=true"
import script from "./adminHeader.vue?vue&type=script&lang=js"
export * from "./adminHeader.vue?vue&type=script&lang=js"
import style0 from "./adminHeader.vue?vue&type=style&index=0&id=0705b978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0705b978",
  null
  
)

export default component.exports